<template>
    <div id="changeShop">
        <div class="scroll" v-if="zxAddressList.length > 0"  :style="{paddingBottom:tabHeight + 'px'}">
          <div @click.stop.prevent="PushZXItemDetail(item,index)" class="AddressItem" v-for="(item,index) in zxAddressList" :key="item.id">
            <div :class="['item', zxActiveIndex === index ? 'active':'']">
              <p class="name">{{item.name}}</p>
              <p class="phone">门店电话:  {{item.phone}}</p>
              <p class="addre">门店地址:{{item.province + ' ' +item.city + ' '+ item.area+" "+item.address}}</p>
              <p class="opening_hours ">营业时间: {{item.shop_hours}}</p>
              <div class="bottomBtn">
              </div>
            </div>
          </div>
        </div>
        <div class="se_btn" :style="{bottom:tabHeight + 'px'}">
            <button @click="changeDei">确认门店</button>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    clickItemDetail: {
      type: Object,
      default: {}
    }
  },
  name: 'changeShop',
  data () {
    return {
      zxAddressList: [],
      zxActiveIndex: 0,
      tabHeight: 0
    }
  },
  methods: {
    PushZXItemDetail (item, index) {
      this.zxActiveIndex = index
    },
    changeDei () {
      this.$emit('changeShopDetail', JSON.stringify(this.zxAddressList[this.zxActiveIndex]))
    },
    getFindByParam () {
      this.utils.get(this.companyUrl + '/customStore/findByParam', {
        province: '',
        city: '',
        area: '',
        page: 1,
        pageSize: 100
      }, res => {
        this.zxAddressList = res.data.rows
        this.zxAddressList.forEach((val, index) => {
          if (val.id == this.clickItemDetail.custom_shop_id) {
            this.zxActiveIndex = index
          }
        })
      })
    },
    androidTabHeight (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = this.tabHeight + parseInt(value)
      }
    }
  },
  mounted () {
    this.getFindByParam()
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      window['androidTabHeight'] = (result) => {
        this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  },
  computed: {

  },
  watch: {
    show (oldvue) {
      console.log(oldvue)
    }
  }
}
</script>

<style lang="scss" scoped>
#changeShop{
  .se_btn{
    height: 42px;
    border-top: 1px solid #EAEAEA;
    position: fixed;
    bottom: 0%;
    width: 100%;
    background: #ffffff;
    button{
      position: absolute;
      width: 70px;
      height: 30px;
      line-height: 28px;
      text-align: center;
      border: 1px solid #C41335;
      border-radius: 5px;
      font-size: 12px;
      background: #C41335;
      color: #ffffff;
      top: 5px;
      right: 15px;
    }

  }
  .scroll::-webkit-scrollbar {
        display: none;
      }
  .scroll{
    width: 100%;
    padding: 0px 1px 0 1px;
    overflow-x: hidden;
    overflow-y: auto;
    display: inline-block;
    margin-bottom: 40px;
    max-height: 320px;

    .AddressItem {
          position: relative;
          border-radius: 4px;
          background: #fff;
          vertical-align: top;

          .item {
            display: inline-block;
            width: 100%;
            border-bottom: 0.01rem solid #eeeeee;
          padding-bottom: 15px;

            .name {
              width: 100%;
              height: 32.5px;
              line-height: 32.5px;
              text-align: left;
              color: #000000;
              font-size: 14px;
              font-weight: bold;
              padding-left: 10.5px;
            }
            .phone {
              width: 100%;
              line-height: 18px;
              font-size: 12px;
              color: #808080;
              text-align: left;
              padding-left: 10.5px;
              margin-bottom: 5px;
            }
            .addre {
              width: 100%;
              padding: 0 10.5px 0 10.5px;
              font-size: 12px;
              color: #808080;
              line-height: 18px;
              margin-bottom: 3px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .detail {
              width: 100%;
              padding: 0 10.5px 0 10.5px;
              font-size: 12px;
              color: #808080;
              line-height: 18px;
              white-space: pre-wrap;
            }
            .opening_hours{
              font-size: 12px;
              color: #808080;
              padding-left: 10.5px;
              margin-top: 5px;
              line-height: 18px;
            }
            .detail-ellipsis{
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }

          }
          .active{
            // border: 1px solid #c41335;
          }
        .active::after {
          content: "";
          position: absolute;
          bottom: -2px;
          right: -3px;
          width: 17px;
          height: 17px;
          background: url("data:image/svg+xml;base64,PHN2ZyB0PSIxNTYyNTc0NjQ0OTk3IiAgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQogICAgICBwLWlkPSI5NDc2IiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIG1lZXQiIHJ4PSc0JyByeT0nNCc+DQogICAgICA8cGF0aA0KICAgICAgICBkPSJNNzk5LjQgMTgwLjQ4SDIyMy44MmE2OS42MiA2OS42MiAwIDAgMC02OS42MSA2OS42MXY1NzUuNThhNjkuNjEgNjkuNjEgMCAwIDAgNjkuNjEgNjkuNkg3OTkuNGE2OS42IDY5LjYgMCAwIDAgNjkuNi02OS42VjI1MC4wOWE2OS42MSA2OS42MSAwIDAgMC02OS42LTY5LjYxeiBtLTQxLjIxIDI0NS44OWwtMjc4IDI3OGEzOC44NiAzOC44NiAwIDAgMS01NSAwTDI2NSA1NDQuMzNhMzguOTIgMzguOTIgMCAwIDEgNTUtNTVsMTMyLjYzIDEzMi41NSAyNTAuNTMtMjUwLjU0YTM4LjkxIDM4LjkxIDAgMSAxIDU1IDU1eiINCiAgICAgICAgcC1pZD0iOTQ3NyIgZmlsbD0iI2M0MTMzNSI+PC9wYXRoPg0KICAgIDwvc3ZnPg==")
          no-repeat center center;
          background-size: contain;
          border-radius: 4px 0 4px 0;
        }
        .active::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border: 1px solid #c41335;
          border-radius: 4px;
        }
        }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/changeShop.vue